import "@arco-design/web-react/es/Carousel/style";
import _Carousel from "@arco-design/web-react/es/Carousel";
import React from 'react';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function Banner() {
  const t = useLocale(locale);
  const data = [{
    slogan: t['banner.slogan1'],
    subSlogan: t['banner.subSlogan1'],
    image: '/images/banner.png'
  }, {
    slogan: t['banner.slogan2'],
    subSlogan: t['banner.subSlogan2'],
    image: '/images/banner.png'
  }, {
    slogan: t['banner.slogan3'],
    subSlogan: t['banner.subSlogan3'],
    image: '/images/banner.png'
  }];
  return /*#__PURE__*/React.createElement(_Carousel, {
    className: styles.carousel,
    animation: "fade"
  }, data.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: `${index}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-title']
  }, item.slogan), /*#__PURE__*/React.createElement("div", {
    className: styles['carousel-sub-title']
  }, item.subSlogan), /*#__PURE__*/React.createElement("img", {
    alt: "banner-image",
    className: styles['carousel-image'],
    src: item.image
  })))));
}